import React from 'react';
import { formatCurrency } from '../../config';

const YearlyComparisonView = ({ yearlyData }) => (
  <div className="space-y-6">
    <div className="bg-white rounded-lg shadow-md p-4 sm:p-6">
      <h3 className="text-lg sm:text-xl font-bold text-gray-900">Year-over-Year Comparison - {yearlyData.plant_name}</h3>
      <p className="text-sm text-gray-600 mt-1">Comparing: {yearlyData.years_compared.join(' vs ')}</p>
    </div>

    <div className="bg-white rounded-lg shadow-md p-4 sm:p-6">
      <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-4">Production & Cost by Year</h3>
      <div className="overflow-x-auto -mx-4 sm:mx-0 px-4 sm:px-0">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Year</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Production (MT)</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Despatches (MT)</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Total Cost</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Cost/MT</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Months</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {yearlyData.data.map((year, idx) => (
              <tr key={year.year} className={idx === 0 ? 'bg-blue-50' : ''}>
                <td className="px-4 py-3 font-bold text-lg">{year.year}</td>
                <td className="px-4 py-3 text-right font-semibold text-blue-600">{year.production_mt}</td>
                <td className="px-4 py-3 text-right">{year.despatches_mt}</td>
                <td className="px-4 py-3 text-right">{formatCurrency(year.total_cost)}</td>
                <td className="px-4 py-3 text-right font-semibold text-[#156ACA]">{formatCurrency(year.cost_per_mt)}</td>
                <td className="px-4 py-3 text-right text-gray-500">{year.months_with_data}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>

    <div className="bg-white rounded-lg shadow-md p-4 sm:p-6">
      <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-4">Efficiency Metrics by Year (per MT)</h3>
      <div className="overflow-x-auto -mx-4 sm:mx-0 px-4 sm:px-0">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Year</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Power (Units/MT)</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Steam (MT/MT)</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Water (KL/MT)</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Oil (L/MT)</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {yearlyData.data.map(year => (
              <tr key={year.year}>
                <td className="px-4 py-3 font-bold">{year.year}</td>
                <td className="px-4 py-3 text-right">{year.efficiency.power_per_mt}</td>
                <td className="px-4 py-3 text-right">{year.efficiency.steam_per_mt}</td>
                <td className="px-4 py-3 text-right">{year.efficiency.water_per_mt}</td>
                <td className="px-4 py-3 text-right">{year.efficiency.oil_per_mt}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>

    <div className="bg-white rounded-lg shadow-md p-4 sm:p-6">
      <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-4">Production Comparison</h3>
      <div className="space-y-4">
        {yearlyData.data.map(year => {
          const maxProduction = Math.max(...yearlyData.data.map(y => y.production_mt));
          const percentage = maxProduction > 0 ? (year.production_mt / maxProduction) * 100 : 0;
          return (
            <div key={year.year} className="flex items-center gap-4">
              <div className="w-16 font-bold text-gray-700">{year.year}</div>
              <div className="flex-1 bg-gray-200 rounded-full h-8 relative">
                <div
                  className="bg-gradient-to-r from-[#156ACA] to-[#0F5299] h-8 rounded-full flex items-center justify-end pr-3"
                  style={{ width: `${percentage}%` }}
                >
                  <span className="text-white font-semibold text-sm">{year.production_mt} MT</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  </div>
);

export default YearlyComparisonView;
